import { lazy } from "react";

export const newAdminPanelRoutes = [
  {
    Path: "/new-admin/*",
    Component: lazy(() => import("../../container/NewAdminPanel/routes.js")),
    meta: {
      name: "Admin Management",
    },
  },
];
